(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/base'), require('@angular/cdk/coercion'), require('@shraddhar/web/checkbox'), require('@shraddhar/web/dom'), require('@material/data-table')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/data-table', ['exports', '@angular/core', '@angular/common', 'rxjs', 'rxjs/operators', '@shraddhar/web/base', '@angular/cdk/coercion', '@shraddhar/web/checkbox', '@shraddhar/web/dom', '@material/data-table'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.dataTable = {}), global.ng.core, global.ng.common, global.rxjs, global.rxjs.operators, global.ng.web.base, global.ng.cdk.coercion, global.ng.web.checkbox, global.ng.web.dom, global.mdc.dataTable));
}(this, (function (exports, core, common, rxjs, operators, base, coercion, checkbox, dom, dataTable) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var uniqueIdCounter = 0;
    var MDCDataTableTable = /** @class */ (function () {
        function MDCDataTableTable(elementRef) {
            this.elementRef = elementRef;
        }
        MDCDataTableTable.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDataTableTable]',
                        exportAs: 'mdcDataTableTable',
                        host: { 'class': 'mdc-data-table__table' }
                    },] }
        ];
        /** @nocollapse */
        MDCDataTableTable.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MDCDataTableTable;
    }());
    var MDCDataTableHeaderRow = /** @class */ (function () {
        function MDCDataTableHeaderRow(elementRef) {
            this.elementRef = elementRef;
        }
        MDCDataTableHeaderRow.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDataTableHeaderRow]',
                        exportAs: 'mdcDataTableHeaderRow',
                        host: { 'class': 'mdc-data-table__header-row' }
                    },] }
        ];
        /** @nocollapse */
        MDCDataTableHeaderRow.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MDCDataTableHeaderRow;
    }());
    var MDCDataTableHeaderCell = /** @class */ (function () {
        function MDCDataTableHeaderCell(elementRef) {
            this.elementRef = elementRef;
            this._numeric = false;
        }
        Object.defineProperty(MDCDataTableHeaderCell.prototype, "numeric", {
            get: function () {
                return this._numeric;
            },
            set: function (value) {
                this._numeric = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MDCDataTableHeaderCell.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcDataTableHeaderCell]',
                        exportAs: 'mdcDataTableHeaderCell',
                        host: {
                            'role': 'columnheader',
                            'scope': 'col',
                            'class': 'mdc-data-table__header-cell',
                            '[class.mdc-data-table__header-cell--checkbox]': '!!_checkbox',
                            '[class.mdc-data-table__header-cell--numeric]': 'numeric'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MDCDataTableHeaderCell.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MDCDataTableHeaderCell.propDecorators = {
            numeric: [{ type: core.Input }],
            _checkbox: [{ type: core.ContentChild, args: [checkbox.MdcCheckbox, { static: false },] }]
        };
        return MDCDataTableHeaderCell;
    }());
    var MDCDataTableContent = /** @class */ (function () {
        function MDCDataTableContent(elementRef) {
            this.elementRef = elementRef;
        }
        MDCDataTableContent.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcDataTableContent]',
                        exportAs: 'mdcDataTableContent',
                        host: { 'class': 'mdc-data-table__content' }
                    },] }
        ];
        /** @nocollapse */
        MDCDataTableContent.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MDCDataTableContent;
    }());
    var MDCDataTableRow = /** @class */ (function () {
        function MDCDataTableRow(elementRef) {
            this.elementRef = elementRef;
            this._id = "mdc-data-table-row-" + uniqueIdCounter++;
            this._selected = false;
        }
        Object.defineProperty(MDCDataTableRow.prototype, "id", {
            /** The unique ID of the row. */
            get: function () {
                return this._id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MDCDataTableRow.prototype, "selected", {
            get: function () {
                return this._selected;
            },
            set: function (value) {
                this._selected = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MDCDataTableRow.prototype.getNativeElement = function () {
            return this.elementRef.nativeElement;
        };
        MDCDataTableRow.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcDataTableRow]',
                        exportAs: 'mdcDataTableRow',
                        host: {
                            '[attr.data-row-id]': 'id',
                            'class': 'mdc-data-table__row',
                            '[class.mdc-data-table__row-checkbox]': '!!_checkbox',
                            '[class.mdc-data-table__row--selected]': 'selected'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MDCDataTableRow.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MDCDataTableRow.propDecorators = {
            _checkbox: [{ type: core.ContentChild, args: [checkbox.MdcCheckbox, { static: false },] }],
            selected: [{ type: core.Input }]
        };
        return MDCDataTableRow;
    }());
    var MDCDataTableCell = /** @class */ (function () {
        function MDCDataTableCell(elementRef) {
            this.elementRef = elementRef;
            this._checkbox = false;
            this._numeric = false;
        }
        Object.defineProperty(MDCDataTableCell.prototype, "checkbox", {
            get: function () {
                return this._checkbox;
            },
            set: function (value) {
                this._checkbox = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MDCDataTableCell.prototype, "numeric", {
            get: function () {
                return this._numeric;
            },
            set: function (value) {
                this._numeric = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MDCDataTableCell.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcDataTableCell]',
                        exportAs: 'mdcDataTableCell',
                        host: {
                            'class': 'mdc-data-table__cell',
                            '[class.mdc-data-table__cell--checkbox]': 'checkbox',
                            '[class.mdc-data-table__cell--numeric]': 'numeric'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MDCDataTableCell.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MDCDataTableCell.propDecorators = {
            checkbox: [{ type: core.Input }],
            numeric: [{ type: core.Input }]
        };
        return MDCDataTableCell;
    }());

    var MDCDataTable = /** @class */ (function (_super) {
        __extends(MDCDataTable, _super);
        function MDCDataTable(elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._headerCheckboxSubscription = null;
            /** Subscription to checkbox events in rows. */
            _this._rowCheckboxesSubscription = null;
            /** Emitted when all rows are selected. */
            _this.selectedAll = new core.EventEmitter();
            /** Emitted when all rows are unselected. */
            _this.unselectedAll = new core.EventEmitter();
            /** Emitted when a row is selected. */
            _this.selectionChanged = new core.EventEmitter();
            return _this;
        }
        Object.defineProperty(MDCDataTable.prototype, "rowCheckboxChanges", {
            /** Combined stream of all checkbox row change events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.rows.map(function (row) { return row._checkbox.change; })));
            },
            enumerable: true,
            configurable: true
        });
        MDCDataTable.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._elementRef.nativeElement.classList.add(className); },
                removeClass: function (className) { return _this._elementRef.nativeElement.classList.remove(className); },
                addClassAtRowIndex: function (rowIndex, className) {
                    return _this.getRows()[rowIndex].getNativeElement().classList.add(className);
                },
                getRowCount: function () { return _this.getRows().length; },
                getRowElements: function () { return [].slice.call(_this.elementRef.nativeElement.querySelectorAll(dataTable.strings.ROW_SELECTOR)); },
                getRowIdAtIndex: function (rowIndex) {
                    return _this.getRows()[rowIndex].getNativeElement().getAttribute(dataTable.strings.DATA_ROW_ID_ATTR);
                },
                getRowIndexByChildElement: function (el) {
                    return _this.getRows().findIndex(function (_) { return _.getNativeElement() === dom.closest(el, dataTable.strings.ROW_SELECTOR); });
                },
                getSelectedRowCount: function () { return _this.elementRef.nativeElement.querySelectorAll(dataTable.strings.ROW_SELECTED_SELECTOR).length; },
                isCheckboxAtRowIndexChecked: function (rowIndex) {
                    return _this.rows.length > 0 && _this.getRows()[rowIndex] && _this.getRows()[rowIndex]._checkbox !== undefined &&
                        _this.getRows()[rowIndex]._checkbox.checked ? true : false;
                },
                isHeaderRowCheckboxChecked: function () { return _this._headerCheckbox ? _this._headerCheckbox.checked : false; },
                isRowsSelectable: function () { return !!_this.elementRef.nativeElement.querySelector(dataTable.strings.ROW_CHECKBOX_SELECTOR); },
                notifyRowSelectionChanged: function (data) {
                    return _this.selectionChanged.emit({
                        index: data.rowIndex,
                        id: data.rowId,
                        selected: data.selected
                    });
                },
                notifySelectedAll: function () { return _this.selectedAll.emit(); },
                notifyUnselectedAll: function () { return _this.unselectedAll.emit(); },
                registerHeaderRowCheckbox: function () { return _this._registerHeaderCheckbox(); },
                registerRowCheckboxes: function () { return _this._registerRowCheckboxes(); },
                removeClassAtRowIndex: function (rowIndex, className) {
                    return _this.getRows()[rowIndex].getNativeElement().classList.remove(className);
                },
                setAttributeAtRowIndex: function (rowIndex, attr, value) {
                    return _this.getRows()[rowIndex].getNativeElement().setAttribute(attr, value);
                },
                setHeaderRowCheckboxChecked: function (checked) { return _this._headerCheckbox.checked = checked; },
                setHeaderRowCheckboxIndeterminate: function (indeterminate) {
                    return _this._headerCheckbox.indeterminate = indeterminate;
                },
                setRowCheckboxCheckedAtIndex: function (rowIndex, checked) {
                    return _this.getRows()[rowIndex]._checkbox ? _this.getRows()[rowIndex]._checkbox.toggle(checked) : null;
                }
            };
            return new dataTable.MDCDataTableFoundation(adapter);
        };
        MDCDataTable.prototype.ngAfterViewInit = function () {
            this._foundation.init();
            this.layoutAsync();
        };
        MDCDataTable.prototype.ngOnDestroy = function () {
            this._destroyed.next();
            this._destroyed.complete();
            this._unsubscribeHeaderCheckbox();
            this._unsubscribeRowCheckboxes();
            if (this._foundation) {
                this._foundation.destroy();
            }
        };
        /**
         * Re-initializes header row checkbox and row checkboxes when selectable rows are added or removed from table.
         * Use this if registering checkbox is asynchronous.
         */
        MDCDataTable.prototype.layoutAsync = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._foundation.layoutAsync()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * Re-initializes header row checkbox and row checkboxes when selectable rows are added or removed from table.
         * Use this if registering checkbox is synchronous.
         */
        MDCDataTable.prototype.layout = function () {
            this._foundation.layout();
        };
        /**
         * @return Returns array of selected row ids.
         */
        MDCDataTable.prototype.getSelectedRowIds = function () {
            return this._foundation.getSelectedRowIds();
        };
        /**
         * Sets selected row ids. Overwrites previously selected rows.
         * @param rowIds Array of row ids that needs to be selected.
         */
        MDCDataTable.prototype.setSelectedRowIds = function (rowIds) {
            return this._foundation.setSelectedRowIds(rowIds);
        };
        MDCDataTable.prototype.getRows = function () {
            return this.rows.toArray();
        };
        MDCDataTable.prototype.getHeaderCheckbox = function () {
            return this._headerCheckbox;
        };
        MDCDataTable.prototype.showProgress = function () {
            this._foundation.showProgress();
        };
        MDCDataTable.prototype.hideProgress = function () {
            this._foundation.hideProgress();
        };
        MDCDataTable.prototype._unsubscribeHeaderCheckbox = function () {
            if (this._headerCheckboxSubscription) {
                this._headerCheckboxSubscription.unsubscribe();
            }
        };
        MDCDataTable.prototype._unsubscribeRowCheckboxes = function () {
            if (this._rowCheckboxesSubscription) {
                this._rowCheckboxesSubscription.unsubscribe();
            }
        };
        MDCDataTable.prototype._registerHeaderCheckbox = function () {
            var _this = this;
            this._unsubscribeHeaderCheckbox();
            var headerRowCheckboxIndex = this.headerCells.toArray().findIndex(function (_) { return _._checkbox !== undefined; });
            this._headerCheckbox = this.headerCells.toArray()[headerRowCheckboxIndex]._checkbox;
            this._headerCheckboxSubscription = this._headerCheckbox.change.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function (_) { return _this._foundation.handleHeaderRowCheckboxChange(); });
        };
        MDCDataTable.prototype._registerRowCheckboxes = function () {
            var _this = this;
            this._unsubscribeRowCheckboxes();
            this._rowCheckboxesSubscription = this.rowCheckboxChanges.subscribe(function (event) {
                _this._foundation.handleRowCheckboxChange({
                    target: event.source._inputElement.nativeElement
                });
            });
        };
        MDCDataTable.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-data-table',
                        exportAs: 'mdcDataTable',
                        host: { 'class': 'mdc-data-table' },
                        template: '<ng-content></ng-content>',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MDCDataTable.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MDCDataTable.propDecorators = {
            selectedAll: [{ type: core.Output }],
            unselectedAll: [{ type: core.Output }],
            selectionChanged: [{ type: core.Output }],
            rows: [{ type: core.ContentChildren, args: [MDCDataTableRow, { descendants: true },] }],
            headerCells: [{ type: core.ContentChildren, args: [MDCDataTableHeaderCell, { descendants: true },] }]
        };
        return MDCDataTable;
    }(base.MDCComponent));

    var DATA_TABLE_DECLARATIONS = [
        MDCDataTable,
        MDCDataTableCell,
        MDCDataTableContent,
        MDCDataTableHeaderCell,
        MDCDataTableHeaderRow,
        MDCDataTableRow,
        MDCDataTableTable
    ];
    var MDCDataTableModule = /** @class */ (function () {
        function MDCDataTableModule() {
        }
        MDCDataTableModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: DATA_TABLE_DECLARATIONS,
                        declarations: DATA_TABLE_DECLARATIONS
                    },] }
        ];
        return MDCDataTableModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDCDataTable = MDCDataTable;
    exports.MDCDataTableCell = MDCDataTableCell;
    exports.MDCDataTableContent = MDCDataTableContent;
    exports.MDCDataTableHeaderCell = MDCDataTableHeaderCell;
    exports.MDCDataTableHeaderRow = MDCDataTableHeaderRow;
    exports.MDCDataTableModule = MDCDataTableModule;
    exports.MDCDataTableRow = MDCDataTableRow;
    exports.MDCDataTableTable = MDCDataTableTable;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-data-table.umd.js.map
